module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11d47O/tc-custom/9781488037207.jpg?1705029192208",
      "alt": "This image is the cover for the book Seduced by the Operative, Code Name: Danger"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Seduced by the Operative, Code Name: Danger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("USA Today")])]), _c('b', [_vm._v(" bestseller Merline Lovelace delivers a thrilling tale of a deadly mission. ")]), _c('br'), _c('br'), _vm._v("For psychologist Claire Cantwell—code name Cyrene—the stakes couldn’t be higher. Tapped for a top-secret mission for the president, the OMEGA covert operative needs the unique expertise of a man she worked with before—and shared a bed!"), _c('br'), _c('br'), _vm._v("Lethally attractive special ops agent and ultrasuave diplomat Luis Esteban wanted more than Claire was ready to give. Now, with their very survival at stake, Claire has to trust Luis with her life…even if that means surrendering the one thing she vowed never to give: her heart."), _c('b'), _c('br'), _c('br'), _c('i', [_vm._v("Originally published in 2009")]), _c('b'), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Merline Lovelace\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("As an Air Force officer, Merline Lovelace served at bases all over the world. When she hung up her uniform for the last time, she combined her love of adventure with a flare for storytelling. She's now produced more than 100 action-packed novels. Over twelve million copies of her works are in print in 30 countries. Named Oklahoma’s Writer of the Year and Female Veteran of the Year, Merline is also a recipient of Romance Writers of America’s prestigious Rita Award.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0